/**
 * Every path, written out literally.
 *
 * The API mixes DRF router routes (which REQUIRE a trailing slash) with
 * hand-written `path()` routes (which must NOT have one). A generic joiner
 * would guess wrong and a slash-less POST does not redirect — it fails.
 */
export const ep = {
  // Hand-written routes — no trailing slash.
  me: "/me",
  accessMe: "/access/me",
  accessMembers: "/access/members",
  accessMember: (telegramId: number) => `/access/members/${telegramId}`,
  accessInvites: "/access/invites",
  facets: "/facets",
  signUpload: "/uploads/sign",
  attachments: (artworkId: string) => `/artworks/${artworkId}/attachments`,
  attachment: (id: string) => `/attachments/${id}`,
  makePrimary: (id: string) => `/attachments/${id}/make-primary`,
  catalogProfile: "/catalog/profile",
  catalogMembers: "/catalog/members",
  catalogMember: (telegramId: number) => `/catalog/members/${telegramId}`,
  catalogInvites: "/catalog/invites",
  sendQr: (id: string) => `/artworks/${id}/send-qr/`,

  // Router routes — trailing slash required.
  artworks: "/artworks/",
  artwork: (id: string) => `/artworks/${id}/`,
  restoreArtwork: (id: string) => `/artworks/${id}/restore/`,
  setPublic: (id: string) => `/artworks/${id}/public/`,
  rotateCode: (id: string) => `/artworks/${id}/rotate-code/`,

  // No login: pages behind printed QR tags and public catalog slugs.
  publicArtwork: (code: string) => `/public/artworks/${encodeURIComponent(code)}`,
  publicCatalog: (slug: string) => `/public/catalogs/${encodeURIComponent(slug)}`,
  artists: "/artists/",
  artist: (id: string) => `/artists/${id}/`,
  taxonomy: "/taxonomy/",
  types: "/taxonomy/types/",
  subtypesOfType: (typeId: string) => `/taxonomy/types/${typeId}/subtypes/`,
  vocabulary: "/vocabulary/",
  vocabularyTerm: (id: string) => `/vocabulary/${id}/`,
} as const;
